import "./EditLocationWarningModal.scss";
import { Modal } from "antd";
import { Button } from "../misc/Button";
import {
  LocationDto,
  SubStatusDtoPlanCycleEnum,
} from "../../../generated/account-client";
import React, { useMemo } from "react";
import { useRecoilState } from "recoil";
import {availableAddonsState, memberState} from "../../../state/atoms";
import { getLocationAddonPrice } from "../../../service/SubscriptionService";
import Price from "../misc/Price";

export interface EditLocationWarningModalProps {
  visible: boolean;
  location: LocationDto;
  onCancel: () => void;
  onContinue: (location: LocationDto) => void;
}

export default function EditLocationWarningModal({
  location,
  visible,
  onCancel,
  onContinue,
}: EditLocationWarningModalProps) {
  const [member] = useRecoilState(memberState);
  const [availableAddons] = useRecoilState(availableAddonsState);
  const locationAddonPrice = useMemo(
    () => getLocationAddonPrice(availableAddons),
    [availableAddons]
  );

  function onAddLocation() {
    onCancel();
    window.MHM.ProModal.addLocation({memberId: member.id, onSuccess: () => window.location.reload()})
  }

  return (
    <Modal
      className={"edit-location-warning-modal clean one"}
      visible={visible}
      onCancel={onCancel}
    >
      <section>
        <header>
          <h2>Update Location</h2>
        </header>

        <p className={"message"}>
          Changes to Business Name or Address will reflect on all Link Pages and
          Online Menus for this location.
        </p>
        <p>
          <Button className={'add-location'} type={"LinkPrimary"} onClick={onAddLocation}>
            <>
            Add a Location for{" "}
            <Price
              amount={locationAddonPrice}
              cycle={SubStatusDtoPlanCycleEnum.Monthly}
              light
            />{" "}
            each
              </>
          </Button>
        </p>
      </section>
      <footer>
        <Button
          type={"Cancel"}
          inverted
          size={"Large"}
          onClick={() => onCancel()}
        >
          <span>Cancel</span>
        </Button>
        <Button
          type={"Primary"}
          size={"Large"}
          onClick={() => {
            onContinue(location);
          }}
        >
          <span>Continue</span>
        </Button>
      </footer>
    </Modal>
  );
}
